import { StandardEvents } from '@shopify/events';

// Product H1 is rendered on the server, including direct variant URLs. Reuse the
// native Horizon request result; do not fetch the whole catalogue or alter SEO canonicals.
const latestRequest = new WeakMap();

document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element) || !event.promise) return;
  if (event.target.closest('product-card')) return;
  const scope = event.target.closest('dialog, .shopify-section');
  if (!scope) return;
  const request = (latestRequest.get(scope) || 0) + 1;
  latestRequest.set(scope, request);

  Promise.resolve(event.promise).then(({ detail } = {}) => {
    if (!scope.isConnected || latestRequest.get(scope) !== request || !detail?.html) return;
    const sourceTitles = [...detail.html.querySelectorAll('[data-beskar-color-title]')];
    for (const title of scope.querySelectorAll('[data-beskar-color-title]')) {
      const productId = detail.newProduct?.id || title.dataset.productId;
      if (detail.productId && !detail.newProduct && String(detail.productId) !== String(title.dataset.productId)) continue;
      const source = sourceTitles.find((candidate) =>
        candidate.dataset.productId === String(productId) &&
        candidate.dataset.blockId === title.dataset.blockId
      );
      if (source) {
        title.textContent = source.textContent;
        title.dataset.productId = source.dataset.productId;
      }
    }
  }).catch((error) => {
    if (error?.name !== 'AbortError') console.warn('[beskar-color-title] Variant update failed:', error);
  });
});
